import { useContext } from "react";

import { NotificationContext } from "./contextNotification";
import { INotificationContext } from "./INotificationContext";

export const useNotification = (): INotificationContext => {
  const { open, close } = useContext(NotificationContext);

  return { open, close };
};
